import styled from 'styled-components';
import { button, colors, spacing } from 'ui/theme';

export const HeaderButtonCell = styled.button`
  ${button}
  display: flex;
  gap: ${spacing.quarter};
  align-items: center;
  background: ${colors.backgroundPrimary};
  border: none;
  padding: ${spacing.base} 0;
  outline: none;

  &[data-sorted-column='true'] {
    color: ${colors.brandPurple};
  }
`;
